const Header = ({ onMenuClick }) => {

    return (
        <div className="toolbar">
            <div className="toolbar-title">
                <button
                    className="mobile-menu-toggle"
                    onClick={onMenuClick}
                    aria-label="Open menu"
                >
                    &#9776;
                </button>

                Next Up</div>
        </div>
    );
};

export default Header;
